import React from "react";
import Modal from "../modal";
import InputField from "common/customInputField";
import isEmpty from "lodash/isEmpty";
import { api } from "store/slices/api";

const EditExceptionPriceModal = (props) => {
  const { editData, searchFields = {}, expPriceValid, handleCancel, handleSave, handleChange, size, storeCcn } = props;
  const laborCode = editData.laborCode;
  const laborCodeDesc = editData.laborCodeDesc ? editData.laborCodeDesc : editData.description;
  const laborCodeDescExt = editData.laborCodeDescExt ? editData.laborCodeDescExt : editData.descriptionExt;
  const storeNbr = storeCcn ? storeCcn : editData.storeNbr;
  const standardInstallerPayRate = editData.standardInstallerPayRate
    ? editData.standardInstallerPayRate
    : editData.standardInstallerRate;
  const standardLaborBillRate = editData.standardLaborBillRate
    ? editData.standardLaborBillRate
    : editData.standardBillRate;
  const exceptionBillRate = editData.exceptionBillRate;
  const expInstallerPayRate = editData.expInstallerPayRate ? editData.expInstallerPayRate : editData.installerRate;
  const accountNbr = editData.accountNumber ? editData.accountNumber : searchFields.accountNumber;
  const accountName = editData.accountName ? editData.accountName : searchFields.accountName;

  const { data: updatedBy } = api.useGetEmployeeQuery(editData.updatedBy, { skip: isEmpty(editData.updatedBy) });

  return (
    <Modal
      title={"Edit Exception Price"}
      saveButtonText={"Save"}
      closeButtonText={"Cancel"}
      handleSave={handleSave}
      handleCancel={handleCancel}
      size={size}
    >
      <form className="search-form-container__fields__form">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Labor Code"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={`${laborCode} - ${laborCodeDesc}`}
              disabled={true}
            />
          </div>

          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Store Number"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={storeNbr}
              disabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Account Number"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={accountNbr}
              disabled={true}
            />
          </div>

          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Account Name"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={accountName}
              disabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Standard Installer Pay Rate"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={standardInstallerPayRate}
              disabled={true}
            />
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Exception Installer Pay Rate"
              id="expInstallerPayRate"
              placeholder="Enter Exception Price"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={expInstallerPayRate}
              onChange={(e) => handleChange(e, true)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Standard Bill Rate"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={standardLaborBillRate}
              disabled={true}
            />
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Exception Bill Rate"
              id="exceptionBillRate"
              placeholder="Enter Exception Price"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={exceptionBillRate}
              onChange={(e) => handleChange(e, true)}
              errorMsg={expPriceValid}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Updated By"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={isEmpty(updatedBy) ? "" : `${updatedBy?.firstname} ${updatedBy?.lastname}`}
              disabled={true}
            />
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 search-form-container__fields__form-group">
            <InputField
              type="text"
              label="Updated Date"
              fieldClasses="form-control search-form-container__fields__form-group__item"
              value={isEmpty(editData.updatedTimeStamp) ? "" : new Date(editData.updatedTimeStamp).toLocaleDateString()}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 margin-b-6">
          <div className="form-group">
            <label htmlFor="LaborCodeDescription" className="margin-b-2">
              <span className="font-family-global font-size-global leading-19px text-black tracking-normal font-medium not-italic">
                Labor Code Description
              </span>
            </label>
            <textarea
              className="form-control height-90px"
              id="LaborCodeDescription"
              disabled={true}
              value={`${laborCode}- ${laborCodeDesc} : ${laborCodeDescExt}`}
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};
export default EditExceptionPriceModal;
